<template>

  <div class="font-nunito text-base text-black dark:text-white dark:bg-slate-900 _mt-[74px] overflow-hidden">
    <nav-bar-component />
    <slide-hero-component class="mb-5"/>
    <product-card-component />
    <about-company-component />
    <step-treat-component />
    <about-company-component-next />
    <grille-hosting-component />
    <video-play-component />
    <data-line-component />
    <about-component />
    <pricing-hosting-component />
    <!-- <testimonial-component /> -->
    <cookie-popup-component />
    <sponsors-component />
    <footer-component />
    <back-to-top-component />
  </div>
</template>

<script>
// @ is an alias to /src
// import { UisStar } from '@iconscout/vue-unicons-solid';
// import { UilVuejs } from '@iconscout/vue-unicons';
import Tailwind from '../assets/css/tailwind.css';
import AddStyle from '../assets/css/add-style.css';


import NavBarComponent from '@/components/NavBarComponent.vue';
import SponsorsComponent from '@/components/SponsorsComponent.vue';
import AboutComponent from '@/components/AboutComponent.vue';
import AboutCompanyComponent from '@/components/AboutCompanyComponent.vue';
import PricingComponent from '@/components/PricingComponent.vue';
import PricingHostingComponent from '@/components/PricingHostingComponent.vue';
import DataLineComponent from '@/components/DataLineComponent.vue';
import FooterComponent from '@/components/footerComponent.vue';
import StepTreatComponent from '@/components/StepTreatComponent.vue';
import AboutCompanyComponentNext from '@/components/AboutCompanyComponentNext.vue';
import BackToTopComponent from '@/components/BackToTopComponent.vue';
import TestimonialComponent from '@/components/TestimonialComponent.vue';
import CookiePopupComponent from '@/components/CookiePopupComponent.vue';
import SlideHeroComponent from '@/components/SlideHeroComponent.vue';
import VideoPlayComponent from '@/components/VideoPlayComponent.vue';
import ProductCardComponent from '@/components/ProductCardComponent.vue';
import GrilleHostingComponent from '@/components/GrilleHostingComponent .vue';
export default {
  name: "HomeView",
  components: {
    // UisStar,
   // UilVuejs,
    Tailwind,
    AddStyle,
    NavBarComponent,
    SponsorsComponent,
    AboutComponent,
    AboutCompanyComponent,
    PricingComponent,
    PricingHostingComponent,
    DataLineComponent,
    FooterComponent,
    StepTreatComponent,
    AboutCompanyComponentNext,
    BackToTopComponent,
    TestimonialComponent,
    CookiePopupComponent,
    SlideHeroComponent,
    VideoPlayComponent,
    ProductCardComponent,
    GrilleHostingComponent
  }
};
</script>

<style></style>